import { writableSession } from './storeUtils';
import { writable } from 'svelte/store';

export const searchedCustomer = writable('');
export const searchedCustomerByDateStart = writable('');
export const searchedCustomerByDateEnd = writable('');
export const isLoggedIn = writableSession('isLoggedIn', false);
